
import { KeyboardStatus } from "@/lib/types/GameTypes";

export const resetKeyboardStatus = (): KeyboardStatus => {
  return {};
};

export const updateKeyboardStatusFromGuesses = (
  guesses: { letter: string; status: string }[][],
): KeyboardStatus => {
  if (!guesses || !Array.isArray(guesses)) {
    return {};
  }

  const result = guesses.reduce((acc, guess) => {
    if (!guess || !Array.isArray(guess)) {
      return acc;
    }
    return updateKeyboardStatus(guess, acc);
  }, {} as KeyboardStatus);
  
  return result;
};

export const updateKeyboardStatus = (
  validatedGuess: { letter: string; status: string }[],
  currentStatus: KeyboardStatus
): KeyboardStatus => {
  // Defensive copy to prevent mutations to the original object
  const newKeyboardStatus = { ...currentStatus };
  
  validatedGuess.forEach(({ letter, status }) => {
    if (!letter) return; // Skip empty letters
    
    // Normalize the status values for consistency
    const keyStatus = status === "misplaced" || status === "wrong-position" ? "wrong-position" : 
                     status === "correct" ? "correct" : 
                     status === "incorrect" ? "incorrect" : "empty";
    
    // Priority rules: correct > wrong-position > incorrect > empty
    if (!newKeyboardStatus[letter] || 
        (keyStatus === "correct") || 
        (keyStatus === "wrong-position" && 
         (newKeyboardStatus[letter] === "incorrect" || newKeyboardStatus[letter] === "empty"))) {
      newKeyboardStatus[letter] = keyStatus;
    }
  });
  
  return newKeyboardStatus;
};
